





























































































































import Vue from 'vue';

export default Vue.extend({
  props: {
    optionsInit: Object,
  },
  data: () => ({
    date: '',
    dateConst: '',
    period: '',
    agregarDialog: false,
    series: [],
    formatoFecha: 'DD/MM/YYYY',
    formatoPeriodo: 'MM/YY',
    selectedSerie: {},
    unidadesPropietariosList: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name', sortable: false  },
      { text: 'Propietario/Inquilino', value: 'propietario.nombre', sortable: false  },
    ],
    unidadesPropietariosSelect: [],
    // unidadesPropietar iosTemp: [],
    options: {
      itemsPerPage: 100,
    },
    isSerieEmpty: true,
    total: 0,
    loading: false,
    menu1: false,
    menu2: false,
    min: '',
    max: '',
    daysLimit: 182,
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    computedPeriodFormatted() {
      return this.$moment(this.period).format(this.formatoPeriodo);
    },
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.log('getSeriesList datos: %o', datos);
        const response = await this.$store.dispatch('getSeriesList', datos);
        console.log('getSeriesList response: %o', response);
        this.series = response;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        const options = this.options;
        // console.log('getUnidadesPropList datos: %o', datos);
        const result = await this.$store.dispatch('getUnidadesPropList', {datos, options});
        // console.log('getUnidadesPropList result: %o', result);
        const unidadesPropietariosTemp = result.content;
        this.unidadesPropietariosList = await this.returnBorradores(unidadesPropietariosTemp);
        console.log('UNIDADES %o', this.unidadesPropietariosList);
        this.total = result.totalElements;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      // try {
      // } catch (e) {
      //   console.error(e);
      //   this.$toast.error(e);
      // }
      this.unidadesPropietariosSelect = [...this.unidadesPropietariosList];
      this.loading = false;
    },
    async pageEventHandler() {
      this.loadData();
    },
    closeDialog() {
      this.$emit('reload', {});
      this.agregarDialog = false;
    },
    async guardarBorradores() {
      if (!this.isSerieEmpty) {
        try {
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const borradores = this.unidadesPropietariosSelect;
          for (const recibo of borradores) {
            recibo.creationDateTime = this.$moment().format();
            recibo.creationUsername = this.$store.getters.getUsername;
            recibo.id = 0;
            recibo.serie = this.selectedSerie.nombre;
            recibo.fechaDeEmision = this.$moment(this.date).format();
            recibo.periodo = this.$moment(this.period).format();
          }
          const datos = {admin, condo, borradores};
          console.log('addLoteBorradores DATOS: %o', datos);
          const result = await this.$store.dispatch('addLoteBorradores', datos);
          console.debug('addLoteBorradores result: %o', result);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.closeDialog();
      } else {
        this.$toast.error('Seleccione una serie');
      }
    },
    async returnBorradores(uniPropArray) {
      const draftArray: any[] = [];
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      let index = 0;
      for (const unidadPropietario of uniPropArray) {
        const draft = {
          ...this.modeloDraft(),
          condominio: condo,
          administracion: admin,
          propietario: {id: unidadPropietario.propId, nombre: unidadPropietario.nombreInquilino},
          unidad: {id: unidadPropietario.unidadId, name: unidadPropietario.nombreUnidad},
          id: index,
        };
        console.debug('draft[%o]: %o', index, draft);
        draftArray.push(draft);
        index++;
      }
      return draftArray;
    },
    rowSelected(event) {
      const boolAndIndex = this.isUniPropInArray(event, this.unidadesPropietariosSelect);
      const isInArray = boolAndIndex.boolValue;
      const index = boolAndIndex.index;
      if (isInArray) {
        this.unidadesPropietariosSelect.splice(index, 1);
      } else {
        this.unidadesPropietariosSelect.push(event);
      }
    },
    modeloDraft() {
      return {
        creationDateTime: '',
        creationUsername: '',
        administracion: {},
        condominio: {},
        unidad: {},
        propietario: {},
        items: [],
        id: 0,
        fechaDeEmision: '',
        folio: 0,
        serie: '',
        status: 'DRAFT',
        subtotal: 0,
        tipoDeComprobante: 'INGRESO',
        total: 0,
      };
    },
    isUniPropInArray(uniProp, uniPropArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const elem of uniPropArray) {
        if (uniProp.unidad.id === elem.unidad.id && uniProp.propietario.id === elem.propietario.id) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
  },
  watch: {
    agregarDialog() {
      if (this.agregarDialog) {
        // this.options = JSON.parse(JSON.stringify(this.optionsInit));
        this.loadData();
        this.date = this.$moment().format();
        this.period = this.date;
        this.max = this.$moment().add(this.daysLimit, 'd').format('YYYY-MM-DD');
        this.min = this.$moment().subtract(this.daysLimit, 'd').format('YYYY-MM-DD');
        this.selectedSerie = {nombre: ''};
      }
    },
    selectedSerie() {
      if (this.selectedSerie.nombre === '') {
        this.isSerieEmpty = true;
      } else {
        this.isSerieEmpty = false;
      }
    },
  },
});
